var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun_profile_956133") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cell/Teacher",
    transform: "translate(-43.000000, -43.000000)",
    fill: "#019ED3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_profile_956133",
    transform: "translate(19.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.000000, 26.000000)",
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1627907,12.8372093 C11.1627907,19.9255814 16.9116279,25.6744186 24,25.6744186 C31.0883721,25.6744186 36.8372093,19.9255814 36.8372093,12.8372093 C36.8372093,5.74883721 31.0883721,0 24,0 C16.9116279,0 11.1627907,5.74883721 11.1627907,12.8372093 Z M33.4883721,12.8372093 C33.4883721,18.0837209 29.2465116,22.3255814 24,22.3255814 C18.7534884,22.3255814 14.5116279,18.0837209 14.5116279,12.8372093 C14.5116279,7.59069767 18.7534884,3.34883721 24,3.34883721 C29.2465116,3.34883721 33.4883721,7.59069767 33.4883721,12.8372093 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2976744,26.1209302 C25.5069767,27.0139535 22.4372093,27.0139535 19.6465116,26.1209302 C13.8976744,24.2232558 7.81395349,25.8976744 4.18604651,30.3627907 C1.50697674,33.655814 0,37.8976744 0,42.1953488 C0,45.3767442 2.62325581,48 5.80465116,48 L42.1953488,48 C45.3767442,48 48,45.3767442 48,42.1953488 C48,37.8976744 46.4930233,33.655814 43.7581395,30.3069767 C40.1302326,25.8976744 34.0465116,24.2232558 28.2976744,26.1209302 Z M42.1953488,44.6511628 L5.80465116,44.6511628 C4.46511628,44.6511628 3.34883721,43.5348837 3.34883721,42.1953488 C3.34883721,38.6232558 4.57674419,35.1627907 6.80930233,32.427907 C8.81860465,29.972093 11.7767442,28.6883721 14.9581395,28.6883721 C16.1860465,28.6883721 17.4139535,28.855814 18.6418605,29.3023256 C22.1023256,30.4186047 25.8976744,30.4186047 29.3581395,29.3023256 C33.7674419,27.8511628 38.4,29.0790698 41.1906977,32.4837209 C43.4232558,35.2186047 44.6511628,38.6790698 44.6511628,42.2511628 C44.6511628,43.5348837 43.5348837,44.6511628 42.1953488,44.6511628 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.338c6f3ffdb64abc07320afa0bd3b075.svg";
export { ForwardRef as ReactComponent };